var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroidIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.88667C0 9.98292 1.82753 11.6783 4.08712 11.6783C6.34672 11.6783 8.17425 9.98292 8.17425 7.88667V5.72H0V7.88667ZM6.49269 1.58708L7.71882 0.449583L7.24005 0L5.89714 1.25125C5.34829 0.996667 4.74106 0.845 4.08712 0.845C3.43318 0.845 2.82595 0.996667 2.28295 1.25125L0.9342 0L0.455422 0.449583L1.68156 1.58708C0.665617 2.275 0 3.38 0 4.63667V5.17833H8.17425V4.63667C8.17425 3.38 7.50863 2.275 6.49269 1.58708ZM2.3355 4.095C2.01437 4.095 1.75162 3.85125 1.75162 3.55333C1.75162 3.25542 2.01437 3.01167 2.3355 3.01167C2.65663 3.01167 2.91937 3.25542 2.91937 3.55333C2.91937 3.85125 2.65663 4.095 2.3355 4.095ZM5.83875 4.095C5.51762 4.095 5.25487 3.85125 5.25487 3.55333C5.25487 3.25542 5.51762 3.01167 5.83875 3.01167C6.15988 3.01167 6.42262 3.25542 6.42262 3.55333C6.42262 3.85125 6.15988 4.095 5.83875 4.095Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidIcon);
export default __webpack_public_path__ + "static/media/androidIcon.23808ff27c98566a08cd3de1b5c921da.svg";
export { ForwardRef as ReactComponent };